<template>
  <div
    :class="rowClasses"
    :style="{
      '--gap': `${gap}px`,
    }"
  >
    <div class="form-col">
      <div
        v-if="$slots.label || label"
        class="form-row__label"
      >
        <slot name="label">
          <form-section-label>
            <div v-html="label" />
          </form-section-label>
        </slot>
      </div>

      <div
        v-if="$slots.question || question"
        class="form-row__question"
      >
        <slot name="question">
          <form-section-question>
            <div v-html="question" />
          </form-section-question>
        </slot>
      </div>

      <div
        v-if="$slots.helpText || helpText"
        class="form-row__help-text"
      >
        <template v-if="Array.isArray(helpText)">
          <help-text
            v-for="(row, index) in helpText"
            :key="index"
            :class="{ 'mt-4': index > 0 }"
            :error="error"
          >
            <p>{{ row }}</p>
          </help-text>
        </template>
        <help-text
          v-else
          :error="error"
        >
          <slot name="helpText">
            <p>{{ helpText }}</p>
          </slot>
        </help-text>
      </div>
    </div>

    <div
      v-if="$slots.default"
      class="form-row__content form-col"
    >
      <slot name="default" />
    </div>
  </div>
</template>

<script>
import FormSectionLabel from '@/components/car/FormSection/FormSectionLabel.vue';
import FormSectionQuestion from '@/components/car/FormSection/FormSectionQuestion.vue';
import HelpText from '@/components/HelpText/HelpText.vue';

export default {
  name: 'form-row',
  components: {
    FormSectionLabel,
    FormSectionQuestion,
    HelpText,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    question: {
      type: String,
      default: null,
    },
    helpText: {
      type: [String, Array],
      default: null,
    },
    optional: {
      type: Boolean,
      default: false,
    },
    isVerticalSplitted: {
      type: Boolean,
      default: false,
    },
    gap: {
      type: [String, Number],
      default: 24,
    },
  },
  computed: {
    rowClasses () {
      return {
        'form-row': 'form-row',
        optional: this.optional,
        columns: this.isVerticalSplitted,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.form-row {
  &__label + * { margin-top: 18px; }
  &__label + &__question { margin-top: 7px; }
  &__label + &__help-text { margin-top: 11px; }
  &__question + * { margin-top: 23px; }
  &__help-text + * { margin-top: 23px; }

  &__content {
    margin-top: 23px;

    & > a {
      font-size: 16px;
      line-height: 16px;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }

  & + & {
    margin-top: 48px;
  }

  &.columns {
    display: block;

    & > .form-col {
      width: 100%;
    }

    .form-row__content {
      margin-top: 23px;
    }
  }

  &::v-deep {
    & + .form-row {
      margin-top: var(--gap, 24px);
    }
  }
}

@media screen and (min-width: 960px) {
  .form-row {
    &.columns {
      display: flex;
      justify-content: space-between;

      & > .form-col {
        width: calc(50% - 12px);
      }

      .form-row__content {
        margin-top: 0;
      }
    }
  }
}
</style>
<style lang="scss" scoped src="@/assets/scss/footer/form-row.scss"/>
